import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import { Manager } from '../../models/manager';
import { Talent } from '../../models/talent';
import DefaultModal from './DefaultModal';

interface Props {
  modalData: { open: boolean; user?: Manager | Talent };
  closeModal: () => void;
  confirmModal: () => void;
}

const ActivateModal = (props: Props): JSX.Element => {
  return (
    <DefaultModal open={props.modalData.open} handleClose={props.closeModal}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Activate User
        </Typography>
        <Typography textAlign="center" mb={1}>
          Your about to activate&nbsp;
          <strong>
            {`${props.modalData?.user?.firstName} ${props.modalData?.user?.lastName}`}
          </strong>
          &nbsp;on your AllWork account. They will able to login and access the
          AllWork Platform.
        </Typography>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={props.closeModal}>
          Cancel
        </Button>
        <Button onClick={props.confirmModal}>Yes, Activate User</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default ActivateModal;
